import * as React from 'react';

import { cn } from './lib/cn';

export interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  invalid?: boolean;
  // Date / datetime fields must use `DateInput` (form package), which tames the
  // browser's calendar-picker indicator. Excluding them here makes the wrong
  // choice a type error rather than a recurring visual bug.
  type?: Exclude<React.HTMLInputTypeAttribute, 'date' | 'datetime-local'>;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', invalid = false, ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      aria-invalid={invalid || props['aria-invalid']}
      className={cn(
        'flex h-control-md w-full rounded-md border bg-surface px-3 py-2 text-base font-sans text-text-primary',
        'placeholder:text-text-placeholder',
        'transition-colors duration-micro ease-out',
        'focus-visible:outline-none focus-visible:border-interactive focus-visible:shadow-focus',
        'disabled:cursor-not-allowed disabled:opacity-60',
        invalid
          ? 'border-danger-500 focus-visible:border-danger-500 focus-visible:shadow-focus-danger'
          : 'border-border',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';

export { Input };
